import { render, staticRenderFns } from "./ComponentRender.vue?vue&type=template&id=21511774&scoped=true"
import script from "./ComponentRender.vue?vue&type=script&lang=js"
export * from "./ComponentRender.vue?vue&type=script&lang=js"
import style0 from "./ComponentRender.vue?vue&type=style&index=0&id=21511774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21511774",
  null
  
)

export default component.exports